export default __webpack_public_path__ + "static/media/55t.dd923405.jpg";